import { Controller } from "@hotwired/stimulus"

// Parent half of the framed-Drupal analytics bridge. app-view pages carry no GTM of their own
// (the parent's per-storefront container owns analytics); the Drupal theme instead posts
// meaningful in-frame activity up as { type: "gtm.event", event, payload } messages, which this
// controller forwards into the parent dataLayer. Attach alongside iframe-resizer on the Drupal
// <iframe>; originValue (drupal_origin) allowlists the one cms origin this env frames.
export default class extends Controller {
  static values = { origin: String }

  connect() {
    this.onMessage = (message) => this.forward(message)
    window.addEventListener("message", this.onMessage)
  }

  disconnect() {
    window.removeEventListener("message", this.onMessage)
  }

  forward({ origin, data }) {
    if (origin !== this.originValue) return
    if (!data || data.type !== "gtm.event" || typeof data.event !== "string") return

    window.dataLayer = window.dataLayer || []
    // Spread payload first so a malicious/buggy payload can never override the event name.
    window.dataLayer.push({ ...(typeof data.payload === "object" ? data.payload : {}), event: data.event })
  }
}
